import { TrueBlueFormTypes } from './from-trueblue.types';

const INITIAL_STATE = {
  error: null,
};

const trueblueFormReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TrueBlueFormTypes.SEND_FORM_DATA_SUCCESS:
      return { ...state, error: null };

    case TrueBlueFormTypes.SEND_FORM_DATA_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default trueblueFormReducer;
